import React from "react";
import { formatCurrency, formatDate, calculateRemaining } from "../utils/financialTransforms";

export default function FinancialTransactionsTable({ records, loading, currency = "€" }) {
    if (loading) {
        return (
            <div className="financial-transactions-table">
                <div className="skeleton skeleton-table-header" />
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="skeleton skeleton-table-row" />
                ))}
            </div>
        );
    }

    if (!records || records.length === 0) {
        return (
            <div className="financial-empty-state">
                <span className="financial-empty-icon">📄</span>
                <p>No financial records found for this apartment.</p>
            </div>
        );
    }

    return (
        <div className="financial-transactions-table financials-table">
            <table>
                <thead>
                    <tr>
                        <th>Tenant</th>
                        <th>Check-in</th>
                        <th>Check-out</th>
                        <th>Paid</th>
                        <th>Expenses</th>
                        <th>Remaining</th>
                    </tr>
                </thead>
                <tbody>
                    {records.map((record, index) => {
                        const rowCurrency = record.currency || currency;
                        const remaining = calculateRemaining(record.amount_paid, record.agent_expenses);

                        return (
                            <tr key={record.id} className={index % 2 === 0 ? "row-even" : "row-odd"}>
                                <td>{record.tenant_name || "—"}</td>
                                <td className="cell-nowrap">{formatDate(record.check_in_date)}</td>
                                <td className="cell-nowrap">{formatDate(record.check_out_date)}</td>
                                <td className="cell-nowrap">
                                    {formatCurrency(record.amount_paid, rowCurrency)}
                                </td>
                                <td className="cell-nowrap">
                                    {formatCurrency(record.agent_expenses, rowCurrency)}
                                </td>
                                <td className="cell-nowrap">
                                    {formatCurrency(remaining, rowCurrency)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
